import type { FleetPlates } from '@chukua/common';
import { api } from '../../shared/shared.api';

/** Public: a few of the company's container rigs, plate and paint, for the login panel's rigs. */
export function getFleetPlates(): Promise<FleetPlates> {
  return api<FleetPlates>('/fleet/plates');
}
